// DEPRECATED Utility - keeping to serve as a image middleware for potential future use-cases.
// Such as image service things, like styling, transform, cropping etc.
var imageServiceUrlBuilder = function (url) {
    return "".concat(url);
};
export default imageServiceUrlBuilder;
